var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ensure-reservation ml-4"},[_c('div',{attrs:{"id":"booking-notice"}},[_c('img',{attrs:{"src":"https://3.cdnpt.com/images/padlock-icon.png"}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.__('messages.secure_your_reservation2')))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.__('messages.add_your_info_text'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }